import { masks } from "@uenf/layout";

masks['conta-contabil'] = {
  mask: '0.0.0.0.0.00.00'
};

masks['year-month'] = {
  mask: '0000/00'
};
